import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap";

// Connects to data-controller="show-modal"
export default class extends Controller {
  connect() {
    this.modal.show()
    document.addEventListener('turbo:submit-end', ev => this.handleSubmit(ev))
  }

  disconnect() {
    this.modal.hide()
    document.removeEventListener('turbo:submit-end', ev => this.handleSubmit(ev))
  }

  close() {
    this.modal.hide()
  }

  handleSubmit(e) {
    console.log(e.detail)
    if (e.detail.success) {
      this.close()
    }
  }

  get modal() {
    return Modal.getOrCreateInstance(this.element)
  }

}
